






















import Vue from "vue";
import { Component } from "vue-property-decorator";
import FormItem from "../components/Money/FormItem.vue";
import Button from "@/components/Button.vue";

@Component({
  components: { Button, FormItem }
})
export default class EditLabels extends Vue {
  // computed
  get currentTag() {
    return this.$store.state.currentTag;
  }
  // hooks
  created() {
    const id = this.$route.params.id;
    this.$store.commit("fetchTag");
    this.$store.commit("setCurrentTag", id);

    if (!this.currentTag) {
      this.$router.replace("/404");
    }
  }
  // methods
  update(name: string) {
    this.$store.commit("updateTag", { id: this.currentTag.id, name });
  }
  remove() {
    if (this.currentTag) {
      this.$store.commit("removeTag", this.currentTag.id);
    }
  }
  goBack() {
    this.$router.back();
  }
}
